import React, { useEffect, useState } from 'react';
import Status from '@components/ui/Status';
import { FuelTooltip } from '@frete.com/fuel-react';
import { formatDateDistance } from '@utils/formatters';
import { useInterval } from '@hooks/useInterval';
import LocationPulse from '../LocationPulse';
import { text } from '../text';
import { LocationWithStatusProps } from './LocationWithStatusTypes';

let dateRequestWithoutLocation = '';

function LocationWithStatus({ location, status }: LocationWithStatusProps) {
  const addInterval = useInterval();
  const [locationDateDistance, setLocationDateDistance] = useState('');
  const [statusDateDistance, setStatusDateDistance] = useState('');
  const statusShowLocation = [
    'in_progress',
    'pending_route',
    'done_by_trucker',
    'trucker:deposit:fee',
    'company:nca:manually',
    'chat:negotiation:automatic',
    'gr:fretebras',
    'inside_pickup_radius',
    'left_pickup_radius',
    'moving_to_delivery',
    'inside_delivery_radius',
    'left_delivery_radius',
  ];
  const textLocationUpdateAt = 'Localização atualizada há ';
  const textStatusUpdateAt = 'Status atualizado há ';
  const addSuffix = false;
  const hasLocation = location.cityName && location.stateAcronym;

  function updateDateDistanceLocation() {
    const updateAt = hasLocation
      ? location.updateAt
      : dateRequestWithoutLocation;

    setLocationDateDistance(formatDateDistance(updateAt, addSuffix));
  }

  function updateDateDistanceStatus() {
    setStatusDateDistance(formatDateDistance(status.updateAt, addSuffix));
  }

  useEffect(() => {
    dateRequestWithoutLocation = new Date().toISOString();

    if (status.updateAt) {
      updateDateDistanceStatus();

      addInterval(() => {
        updateDateDistanceStatus();
      }, 1000);
    }

    if (hasLocation) {
      updateDateDistanceLocation();

      addInterval(() => {
        updateDateDistanceLocation();
      }, 1000);
    }

    if (!hasLocation) {
      updateDateDistanceLocation();

      addInterval(() => {
        updateDateDistanceLocation();
      }, 1000);
    }
  }, []);

  if (statusShowLocation.includes(status.slug)) {
    if (!hasLocation) {
      return (
        <FuelTooltip
          label={`${textLocationUpdateAt}${locationDateDistance}`}
          content={
            statusDateDistance
              ? `${textStatusUpdateAt}${statusDateDistance}.`
              : undefined
          }
          placement="bottom-start"
        >
          <div>
            <LocationPulse
              text={text.location.noCity}
              isPulse={false}
              isInactive
            />
            <Status status={status.slug} isTruncateText />
          </div>
        </FuelTooltip>
      );
    }

    return (
      <FuelTooltip
        label={`${textLocationUpdateAt}${locationDateDistance}.`}
        content={
          statusDateDistance
            ? `${textStatusUpdateAt}${statusDateDistance}.`
            : undefined
        }
        placement="bottom-start"
      >
        <div>
          <LocationPulse
            text={`Em ${location.cityName}, ${location.stateAcronym}`}
          />
          <Status status={status.slug} isTruncateText />
        </div>
      </FuelTooltip>
    );
  }

  return (
    <FuelTooltip
      label={
        statusDateDistance
          ? `${textStatusUpdateAt}${statusDateDistance}.`
          : undefined
      }
      placement="bottom-start"
    >
      <Status status={status.slug} isTruncateText />
    </FuelTooltip>
  );
}

export default LocationWithStatus;
